import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core';
import { getI18n } from "../../../utils/intl";

import FormTextField from "../../FormTextField";

import styles from './styles';

const FilterByRank = (props) => {
  const { updatedFilterRankSize, maxAllowedEntities, updateRankSize, hideCount = false } = props;

  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const [state, updateState] = useState({
    rankSize: 3,
    invalidInput: false,
  });

  const setState = (value) => {
    if (typeof value === 'function') {
      updateState(currentValue => ({ ...currentValue, ...value(state) }));
    } else {
      updateState(currentValue => ({ ...currentValue, ...value }));
    }
  }

  useEffect(() => {
    if (updatedFilterRankSize !== state.rankSize) {
      setState({ rankSize: updatedFilterRankSize });
    }
  }, [updatedFilterRankSize]);
  
  const handleRankSizeInputChange = value => {
    const patt1 = new RegExp('^(?:[1-9]|0[1-9]|10)$');
    let isInvalid = false;
    if (!value || !patt1.test(value) || value > maxAllowedEntities) {
      isInvalid = true;
    }
    updateRankSize(value, isInvalid);
    setState({ value, invalidInput: isInvalid });
  };

  const incRankSize = () => {
    let { rankSize } = state;
    const patt1 = new RegExp('^(?:[1-9]|0[1-9]|10)$');
    const patt2 = new RegExp('[!@#$%^&*(),.?":{}|<>a-z.+=`]');
    const containsChar = patt2.test(rankSize);
    let isInvalid = false;
    rankSize =
      rankSize !== maxAllowedEntities && !containsChar && !isNaN(parseInt(rankSize, 10))
        ? rankSize + 1
        : rankSize;
    if (!rankSize || (rankSize && !patt1.test(rankSize)) || (rankSize > maxAllowedEntities)) {
      isInvalid = true;
    } else {
      isInvalid = false;
    }
    updateRankSize(rankSize, isInvalid);
    setState({ rankSize, invalidInput: isInvalid });
  };

  const decRankSize = () => {
    let { rankSize } = state;
    const patt1 = new RegExp('^(?:[1-9]|0[1-9]|10)$');
    const patt2 = new RegExp('[!@#$%^&*(),.?":{}|<>a-z.+=`]');
    const containsChar = patt2.test(rankSize);
    let isInvalid = false;
    rankSize =
      rankSize !== 1 && !containsChar && !isNaN(parseInt(rankSize, 10))
        ? rankSize - 1
        : rankSize;
    if (
      !rankSize ||
      (rankSize && !patt1.test(rankSize)) ||
      rankSize > maxAllowedEntities ||
      rankSize < 0
    ) {
      isInvalid = true;
    }
    if (rankSize <= maxAllowedEntities && !rankSize < 0) {
      isInvalid = false;
    }
    updateRankSize(rankSize, isInvalid);
    setState({ rankSize, invalidInput: isInvalid });
  };

  const { rankSize } = state;
  let remainingSlots = maxAllowedEntities;
  if (!state.invalidInput && Number.isInteger(rankSize)) {
    remainingSlots =
      maxAllowedEntities - rankSize < 0 || rankSize < 0
        ? maxAllowedEntities
        : maxAllowedEntities - rankSize;
  }
    
  return (
    <div className={classes.filterRankContainer}>
      <div className={classes.filterRankSizeContainer}>
        <div className={classes.label}>Ranking Size</div>
        <div className={classes.inputField}>
          <FormTextField
            fieldContainerClass={clsx(
              classes.textInput,
              state.invalidInput ? classes.invalidTextInput : null,
            )}
            textFieldClass={classes.textInputField}
            type={'number'}
            value={state.rankSize.toString()}
            handleChange={handleRankSizeInputChange}
            hideLabel
          />
          <button data-apim-test={'rank-plus-btn'} className={classes.rankSizeBtn} onClick={incRankSize}>
            ＋
          </button>
          <button data-apim-test={'rank-minus-btn'} className={classes.rankSizeBtn} onClick={decRankSize}>
            －
          </button>
        </div>
        {hideCount ? null : (
          <div className={classes.helperMessage}>
            {' '}
            {remainingSlots}/{maxAllowedEntities} data slots remaining
          </div>
        )}
        {state.invalidInput ? (
          <p className={classes.errorMessage}>
            {intl.getI18nMessage('label.analytics.filter.filterByRank.errorMessage.text')}
          </p>
        ) : null}
      </div>
    </div>
  );
  
}

FilterByRank.propTypes = {
  updateRankSize: PropTypes.func,
  updatedFilterRankSize: PropTypes.number,
  maxAllowedEntities: PropTypes.number,
  hideCount: PropTypes.bool,
};

export default FilterByRank;